/** Layout Admin */

(function (fox, $) {
  "use strict";
  const windowUtils = require("../../../../components/utils/window")(fox, $);
  const links = require("../../../../components/utils/links")(fox);
  const CONSTANTS = require("../../../../components/utils/constants")(fox, $);
  var _ = {
    getTranslation: function (alias) {
      var translation = {
        communityNickname: fox.i18n.getTranslation(
          "communityNickname",
          "Community Nickname",
          "dialog"
        ),
        cancel: fox.i18n.getTranslation("cancel", "Cancel", "dialog"),
        save: fox.i18n.getTranslation("save", "Save", "dialog"),
        uploadFailedWrongFileFormat: fox.i18n.getTranslation(
          "uploadFailedWrongFileFormat",
          "The upload has failed. Please make sure you are uploading a supported file type:",
          "notifications"
        ),
        messageSuccessfullySent: fox.i18n.getTranslation(
          "messageSuccessfullySent",
          "Your message(s) was successfully sent.",
          "notifications"
        ),
        pleaseNote: fox.i18n.getTranslation(
          "pleaseNote",
          "Please note",
          "dialog"
        ),
      };

      return translation[alias] || "";
    },
  };

  fox.registerWidget(
    "Layout_Admin",
    {
      configure: function () {
        this.registerOptions("", {
          template: "layout_admin",
          pageContainer: "#mc-page-container",
          autoRender: true,
          templateOptions: {
            isDesktop: Number(
              windowUtils.isWidthUp(CONSTANTS.desktopBreakPoint, true)
            ),
          },
          widgets: {
            header: {
              widget: "Layout_Admin_Header",
            },
            sidebarMenu: {
              widget: "Menu_Sidebar",
            },
            footer: {
              widget: "Widget",
              autoRender: "true",
              container: "#member-footer-links",
              template: "member_footer_links",
              "widgets.popupCCPA.widget": "Popup_CCPA",
              "widgets.popupSuccess.widget": "Popup_CCPA_Succsess",
            },
            windowScrollHandler: {
              widget: "WindowScrollHandler",
              targetWidget: "@parent",
              targetSelector: ".fixed-sidebar",
              customEnabling: true,
              bottomOffset: 0,
            },

            //global popups
            createCommunityName: {
              widget: "PopupWidget",
              title: _.getTranslation("communityNickname"),
              additionalClass: "new-member-container",
              dialog: {
                width: "470px",
                buttons: [
                  {
                    text: _.getTranslation("cancel"),
                    class: "mc-btn btn-small btn-minor close",
                    id: "cancel-communityName",
                  },
                  {
                    text: _.getTranslation("save"),
                    class:
                      "mc-btn btn-small btn-casual button-with-spinner white",
                    id: "save-communityName",
                  },
                ],
              },
              widgets: {
                communityNamePopup: {
                  widget: "Popup_CommunityName",
                  autoRender: true,
                },
              },
            },
            mobileNotificationPopup: {
              widget: "PopupWidget",
              dialog: {
                dialogClass:
                  "ui-dialog dlg-amc dark-overlay mobile-notification-popup dlg-amc-error",
                title: _.getTranslation("pleaseNote") + "!",
              },
              widgets: {
                content: {
                  widget: "Widget",
                  autoRender: true,
                  template: "popup_mobile_notification",
                },
              },
            },
            IENotificationPopup: {
              widget: "PopupWidget",
              dialog: {
                dialogClass:
                  "ui-dialog dlg-amc dark-overlay mobile-notification-popup dlg-amc-error",
                title: _.getTranslation("pleaseNote") + "!",
              },
              widgets: {
                content: {
                  widget: "Widget",
                  autoRender: true,
                  template: "popup_IE_notification",
                },
              },
            },
          },

          handleWom: {
            headerAddedToDom: {
              widget: "#header",
              event: "addedToDom",
              callback: "_applyScrollHandler",
            },
            _handleTopPointPass: {
              widget: "#windowScrollHandler",
              event: "topPointReached",
              callback: "_handleTopPointPass",
            },

            fileOnUploadIsValid: {
              event: "fileIsValid",
              widget: "~.Form_Element_FileUploaderInterface",
              callback: function () {
                fox.wom
                  .selectFirst("~#throughNotifications")
                  .pullNotification("uploader.fileIsValid");
              },
            },

            fileOnUploadNotValid: {
              event: "fileNotValid",
              widget: "~.Form_Element_FileUploaderInterface",
              callback: function (params, uploader, alias) {
                if (uploader.getOption("skipRootNotification")) return false;

                var data = {
                  noticeMessage: [
                    _.getTranslation("uploadFailedWrongFileFormat") + " ",
                    params.validExt.join(", "),
                  ].join(""),
                  noticeType: "error",
                  noticeAlias: "uploader.fileIsValid",
                  listenWidgetDeactivate: uploader,
                };

                fox.wom
                  .selectFirst("~#throughNotifications")
                  .pushNotification(data);
              },
            },

            fileOnUploadNotValidFromUploads: {
              event: "wrongFileTypes",
              widget: "~.Editor_Uploads",
              callback: function (params, w, alias) {
                var data = {
                  noticeMessage: [
                    _.getTranslation("uploadFailedWrongFileFormat") + " ",
                    params.validExt.join(", "),
                  ].join(""),
                  noticeType: "error",
                  noticeAlias: "uploads.wrongFileTypes",
                  listenWidgetDeactivate: w,
                };

                fox.wom
                  .selectFirst("~#throughNotifications")
                  .pushNotification(data);
              },
            },

            messageSuccessfullySend: {
              event: "messageSended",
              widget: "~.Popup_NewMessage",
              callback: function () {
                var data = {
                  noticeMessage: _.getTranslation("messageSuccessfullySent"),
                  noticeType: "success",
                  delayClose: 8000,
                  noticeAlias: "messageSended",
                };

                fox.wom
                  .selectFirst("~#throughNotifications")
                  .pushNotification(data);
              },
            },

            newMessagesCount: {
              event: "cameNewMessages",
              widget: "@root #newMessageCount",
              "params.prefix": "formessagecounter",
              callback: function (data) {
                var mn = this.dom1(".new-counter.messages");

                if (fox.dom.isDomNode(mn)) {
                  mn.innerHTML =
                    data.total > 0 ? ["+", data.total].join("") : "";
                }
              },
            },
          },
        });

        this.registerOptions(".Site_Page");

        this.callParent("configure", arguments);
      },

      init: function () {
        var logo = fox.getEnv("siteLogo");

        if (fox.getEnv("public.agencyId") > 0 && logo) {
          this.setTemplateOptions({ siteLogo: logo });
        }
        this.isDesktop = 1;
        this.callParent("init", arguments);
      },

      running: function () {
        this.handleEvent(
          fox.site,
          "loadedConversationList",
          fox.bind(this.initConversationList, this)
        );

        var xDomain = fox.cookie.get("xxx_domain");
        if (xDomain && !fox.cookie.get("showInformationPopup")) {
          this.rwom1("#xDomainChecker").checkXDomain(xDomain);
        }
        this.callParent("running", arguments);
      },

      addedToDom: function () {},

      showNotice: function (params) {
        this.rwom1("~#throughNotifications").pushNotification(params);
      },

      hideNotice: function () {
        this.rwom1("~#throughNotifications").pullAllNotifications();
      },

      showInformationPopup: function () {
        if (fox.cookie.get("showInformationPopup")) {
          setTimeout(
            fox.bind(function () {
              this.rwom1("#informationPopup").show();
            }, this),
            1000
          );

          fox.cookie.remove("showInformationPopup");
        }
      },

      showMobileNotificationPopup: function (argument) {
        if (!!fox.getEnv("getConsents")) {
          return fox.site.wait("@root", "gdpr_consents_accepted").then(() => {
            if (
              fox.utils.isTouchDevice() &&
              fox.utils.getViewportSize().width < 1024 &&
              sessionStorage.getItem("showMobileNotice") == null
            ) {
              this.wom1("#mobileNotificationPopup").show();
              sessionStorage.setItem("showMobileNotice", "1");
            }
            return true;
          });
        } else {
          if (
            fox.utils.isTouchDevice() &&
            fox.utils.getViewportSize().width < 1024 &&
            sessionStorage.getItem("showMobileNotice") == null
          ) {
            setTimeout(
              fox.bind(function () {
                this.wom1("#mobileNotificationPopup").show();
                sessionStorage.setItem("showMobileNotice", "1");
              }, this),
              3000
            );
          }
        }
      },

      showIENotificationPopup: function (argument) {
        var version = this.detectIE();
        if (version && version <= 12) {
          this.wom1("#IENotificationPopup").show();
        }
      },

      initConversationList: function (object) {
        this.wom1("#sendMemberMessage #newMessagePopup").setList(object);
      },

      showMessagePopup: function (member, attachments) {
        var messageWidget = this.wom1("#sendMemberMessage #newMessagePopup");

        messageWidget.loadMember(member);

        if (fox.isArray(attachments)) {
          messageWidget.attachContent(attachments);
        }

        messageWidget.wom1("@parent").show();
      },

      _applyScrollHandler: function () {
        window.setTimeout(
          fox.bind(function () {
            var headeHeight = this.wom1("#header").getHeight();
            this.wom1("#windowScrollHandler").setTopOffset(headeHeight);
            this.wom1("#windowScrollHandler").enable();
          }, this),
          2000
        );
      },

      _handleTopPointPass: function (d) {
        var elm = $(this.dom1(".fixed-sidebar"));
        var mainContainer = $(this.dom1("#mc-page-container"));
        if (
          d.direction > 0 &&
          $(window).height() > elm.height() &&
          elm.height() < mainContainer.height()
        ) {
          elm.css({
            width: elm.parent().width() + "px",
            top: "20px", //(this.wom1('#windowScrollHandler').getScrolledHeight() + 20) + 'px'
          });
          elm.addClass("slide");

          return;
        } else {
          elm.css({ width: "auto", top: 0 });
          elm.removeClass("slide");
        }
      },

      showCreateCommunityNamePopup: function () {
        this.rwom1("#createCommunityName").show();
      },

      detectIE: function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
        }

        var trident = ua.indexOf("Trident/");
        if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf("rv:");
          return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
        }

        var edge = ua.indexOf("Edge/");
        if (edge > 0) {
          // Edge (IE 12+) => return version number
          return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
        }

        return false;
      },
    },
    "Site_Layout"
  );
})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/layout/admin/admin.es.js